import { DropdownOptions, FormProvider, ModalProvider, TooltipPopup } from 'dash-ui';
import CompleteSignUpPageLayout from 'flow-components/CompleteSignUpPageLayout/CompleteSignUpPageLayout';

import AddAdditionalInfoForm from 'pages/authentication/complete-sign-up-scope/AddAdditionalInfoPage/component/AddAdditionalInfoForm/AddAdditionalInfoForm';
import { FormFieldsList } from 'pages/authentication/complete-sign-up-scope/AddAdditionalInfoPage/component/AddAdditionalInfoForm/constants/constants';
import { CropImageModal } from 'pages/ProfilePage/components/AccountInfo/components/AccountInfoForm/components/CropImageModal';

function AddAdditionalInfoPage() {
  return (
    <ModalProvider>
      <CompleteSignUpPageLayout activeStep={1}>
        <DropdownOptions />
        <TooltipPopup />
        <FormProvider fieldsList={FormFieldsList}>
          <AddAdditionalInfoForm />
          <CropImageModal />
        </FormProvider>
      </CompleteSignUpPageLayout>
    </ModalProvider>
  );
}

export default AddAdditionalInfoPage;
